import React, { useEffect, useState } from "react";

import { useValidateSpelling } from "../../../shared/spell-check";

const withSpellcheck = (WrappedComponent) => (props) => {
    const validateSpelling = useValidateSpelling();
    const [spellingErrors, setSpellingErrors] = useState(() => validateSpelling(props.defaultValue, props.validation));

    useEffect(() => {
        const newSpellingErrors = props.defaultValue ? validateSpelling(props.defaultValue, props.validation) : [];
        setSpellingErrors(newSpellingErrors);
    }, [props.defaultValue]);

    const hasMistakes = spellingErrors.length > 0;
    const errorClass = hasMistakes ? "-error-spelling" : "";
    const spellingMsg = hasMistakes ? (
        <div className="spelling-message">
            <p>Spelling Concerns: {spellingErrors.join(", ")}</p>
        </div>
    ) : null;

    return (
        <div className={`spelling-wrapper ${errorClass}`}>
            <WrappedComponent
                {...props}
                spellingErrors={spellingErrors}
            />
            {spellingMsg}
        </div>
    );
};

withSpellcheck.defaultProps = {
    validation: {
        errorMsg: null,
    },
};

export default withSpellcheck;
